import React, { useEffect, useState } from "react";
import { api_url } from "../../helpers/apiHelpers";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import { font } from "./NotoSansDevanagari-Regular-normal";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import moment from "moment";
import { Bold } from "lucide-react";

const GpfnrWorkPrint = () => {
  const navigate = useNavigate();
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const [GPFNRData, setGPFNRData] = useState([]);

  const getGPFNRData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-gpfnr-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        const data = result.result.find((item) => item._id === route);
        setGPFNRData(data);
      } else {
        setGPFNRData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getGPFNRData();
  }, []);

  const [formData, setFormData] = useState(null);
  const [deductionData, setDeductionData] = useState(null);

  useEffect(() => {
    try {
      if (GPFNRData?.formData) {
        setFormData(JSON.parse(GPFNRData.formData));
      }
      if (GPFNRData?.deductionData) {
        setDeductionData(JSON.parse(GPFNRData.deductionData));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [GPFNRData]);
  // console.log(GPFNRData);

  // const generatePrintablePage = async () => {
  //   // Add dynamic CSS for consistent padding and margin
  //   const style = document.createElement("style");
  //   style.innerHTML = `
  //     * {
  //       padding-top: 0px !important;
  //       padding-bottom: 0px !important;
  //       margin-top: 0px !important;
  //       font-size: 16px !important;
  //       color:#000 !important;
  //       box-sizing: border-box; /* Maintain consistent sizing */
  //     }
  //     div {
  //       page-break-inside: avoid; /* Avoid breaking sections between pages */
  //     }
  //     #main_table1,
  //     #main_table2,
  //     #main_table3{
  //     border:0 !important;
  //     }
  //     #button-section {
  //       display: none; /* Hide button section during print */
  //     }
  //     @page {
  //       size: A4; /* Set the page size to A4 */
  //       margin: 10mm; /* Set page margin */
  //     }
  //     @media print {
  //       body * {
  //         visibility: hidden; /* Hide everything by default */
  //       }
  //       #print-wrapper, #print-wrapper * {
  //         visibility: visible; /* Only make print-wrapper visible */
  //       }
  //     }
  //   `;
  //   document.head.appendChild(style); // Append the style tag

  //   // Update the order to print section5 first, followed by other sections
  //   const sections = [
  //     document.getElementById("section5"), // Print section5 first
  //     document.getElementById("section1"),
  //     document.getElementById("section2"),
  //     document.getElementById("section3"),
  //     document.getElementById("section4"),
  //     document.getElementById("section6"),
  //     document.getElementById("section7"),
  //   ];

  //   // Create a new wrapper for printing all sections
  //   const printWrapper = document.createElement("div");
  //   printWrapper.id = "print-wrapper"; // Set an ID for the wrapper

  //   for (let i = 0; i < sections.length; i++) {
  //     let section = sections[i];

  //     // Clone each section and append to printWrapper
  //     if (section) {
  //       printWrapper.appendChild(section.cloneNode(true));
  //     }
  //   }

  //   // Append the print wrapper to the body
  //   document.body.appendChild(printWrapper);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up: Remove the printWrapper and style from the document
  //   document.body.removeChild(printWrapper);
  //   document.head.removeChild(style);
  // };

  const generatePrintablePage = async () => {
    // Add dynamic CSS for consistent padding and margin
    const style = document.createElement("style");
    style.innerHTML = `
      * {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        margin-top: 0px !important;
        font-size: 16px !important;
        color:#000 !important;
        box-sizing: border-box; /* Maintain consistent sizing */
      }

      div {
        page-break-inside: avoid; /* Avoid breaking sections between pages */
      }
      #main_table1,
      #main_table2,
      #main_table3,
      #bank-details {
        border: 0 !important;
      }
      #section5,
      #section1,
      #section2,
      #section3,
      #section4,
      #section6,
      #section7{
      padding:30px 20px !important;
      margin-left:40px !important;
      }
      #section2{
      margin-bottom:100px !important;
      }
      #button-section {
        display: none; /* Hide button section during print */
      }
      @page {
        size: A4; /* Set the page size to A4 */
        margin: 10mm; /* Set page margin */
      }
      #vetan_certi_table1 td, #vetan_certi_table1 th,
      #vetan_certi_table2 td, #vetan_certi_table2 th{
        font-weight: bold;
      }
      #vetan_certi_table3 th, #vetan_certi_table3 td {
        padding: 8px 15px !important;
        border: 1px solid #000;
        border-collapse: collapse;
        font-size: 16px !important;
      }
      @media print {

        #print-wrapper, #print-wrapper * {
          visibility: visible; /* Only make print-wrapper visible */
        }
        /* Avoid unwanted blank pages */
        #print-wrapper {
          page-break-before: auto; /* Force the print content to start at the top */
        }
      }
    `;
    document.head.appendChild(style); // Append the style tag

    // Update the order to print section5 first, followed by other sections
    const sections = [
      document.getElementById("section5"), // Print section5 first
      document.getElementById("section1"),
      document.getElementById("section2"),
      document.getElementById("section3"),
      document.getElementById("section4"),
      document.getElementById("section6"),
      document.getElementById("section7"),
    ];

    // Create a new wrapper for printing all sections
    const printWrapper = document.createElement("div");
    printWrapper.id = "print-wrapper"; // Set an ID for the wrapper

    for (let i = 0; i < sections.length; i++) {
      let section = sections[i];

      // Clone each section and append to printWrapper
      // if (section && section.innerHTML.trim() !== "") {
      // Check if the section has content
      printWrapper.appendChild(section);
      // }/
    }

    // If no valid sections are added, do not trigger print dialog
    if (printWrapper.children.length > 0) {
      // Append the print wrapper to the body
      document.body.appendChild(printWrapper);

      // Trigger the print dialog
      window.print();

      // Clean up: Remove the printWrapper and style from the document
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };

  const numberToText = (num) => {
    const ones = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    const tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    const thousands = ["", "thousand", "lakh", "crore"]; // Indian system of numbering

    if (num === 0) return "zero rupees";

    let result = "";
    let chunkIndex = 0;

    while (num > 0) {
      let chunk = num % 1000;
      if (chunk > 0) {
        result =
          convertChunk(chunk) +
          (thousands[chunkIndex] ? " " + thousands[chunkIndex] : "") +
          " " +
          result;
      }
      num = Math.floor(num / 1000);
      chunkIndex++;
    }

    return result.trim() + " rupees";

    function convertChunk(num) {
      if (num === 0) return "";

      let chunkResult = "";
      if (num >= 100) {
        chunkResult += ones[Math.floor(num / 100)] + " hundred ";
        num %= 100;
      }
      if (num >= 20) {
        chunkResult += tens[Math.floor(num / 10)] + " ";
        num %= 10;
      }
      if (num > 0) {
        chunkResult += ones[num];
      }

      return chunkResult.trim();
    }
  };

  const convertAmountToText = (amount) => {
    const [whole, cents] = amount.toString().split(".");
    let amountText = numberToText(parseInt(whole));

    // Handle paise (cents) if present
    if (cents) {
      let centsText =
        parseInt(cents) === 0
          ? "zero paise"
          : numberToText(parseInt(cents)) + " paise";
      return `${amountText} and ${centsText}`;
    }

    return amountText;
  };
  return (
    <div className="container-xl py-5">
      <button
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/gpf_non_refundable_work")}
      >
        Back
      </button>
      <div className="gpfnr-main-div mt-3" id="gpfnr-main-div">
        <div
          id="section1"
          style={{ border: "1px solid #000", paddingBottom: "30px" }}
        >
          <h4 id="main-heading">फॉर्म क्र. ३</h4>
          <h4 id="main-heading">
            भविष्य निर्वाह निधीमधून ना परतावा अग्रीम धन मिळणे बाबत चा अर्ज{" "}
          </h4>
          <div className="main-body py-3 px-4">
            <table id="main_table1" className="main-list mt-3">
              <tr>
                <td>कार्यालयाचे नाव</td>
                <td colSpan={3}>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.officeName}
                  </span>
                </td>
              </tr>
              <tr>
                <td>१ अर्जदाराचे नाव</td>
                <td colSpan={3}>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.applicantName}
                  </span>
                </td>
              </tr>
              <tr>
                <td>२ अर्जदाराचे पदनाव </td>
                <td colSpan={3}>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.designation}
                  </span>
                </td>
              </tr>
              <tr>
                <td>३ भ नि नि क्रमांक </td>
                <td colSpan={3}>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.gpfNumber}
                  </span>
                </td>
              </tr>
              <tr>
                <td> ४ वेतन श्रेणी </td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.salaryRange}
                  </span>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td> ५ मासिक मूळ पगार </td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.baseSalary}
                  </span>
                </td>
                <td> ६ माहे वेतन</td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.salaryMonth}
                  </span>
                </td>
              </tr>
              <tr>
                <td>७ जन्म दिनांक </td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.dob}
                  </span>
                </td>
                <td>८ सेवा निवृत्ती दिनांक</td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.retirementDate}
                  </span>
                </td>
              </tr>
              <tr>
                <td>९ प्रथम नेमणूक दिनांक </td>
                <td>
                  :-{" "}
                  <span className="text-danger">
                    {formData && formData.firstAppointmentDate}
                  </span>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td colSpan={4}></td>
              </tr>
              <tr>
                <td colSpan={4}>
                  १० अर्जदाराचे खाती अर्ज करते वेळी जमा असलेली रक्कम खालील
                  प्रमाणे :-
                </td>
              </tr>
            </table>
            <div className="container my-4">
              <div className="container-xl">
                <table className="main-list w-75 " id="main_table2">
                  <tr>
                    <td>
                      १ मा.मु.ले. व वि.अ. यांनी सन २०२३-२०२४ मध्ये प्रमाणित
                      केलेली रक्कम,
                    </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field1}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>२ चालू वर्षात मासीक हप्त्याची जमा रक्कम </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field2}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>३ सातवा वेतन आयोग ५ ला जमा हप्ता </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field3}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>४ एकूण खात्यावर जमा असलेली रक्कम </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.totalField4}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>५ उपरोक्त कालावधीत घेतलेले कर्ज </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field4}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>६ अर्जदाराचे खाती निव्वळ शिल्लक रक्कम </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.remainingField6}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>७ पूर्वीच्या कर्जापैकी येणे बाकी असलेली रक्कम </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field5}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>८ आता मागणी केलेले कर्ज (जमारक्कम * ३/४) </td>
                    <td className="text-right">
                      <span className="text-danger">
                        {GPFNRData && GPFNRData.field6}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <table className=" main-list my-4" id="main_table3">
              <tr>
                <td>१२ कोणत्या कारणासाठी अग्रीम धनाची आवश्यकता आहे :-</td>
                <td className="text-left">
                  {formData && formData.reasonForAdvance}
                </td>
              </tr>
              <tr>
                <td>१३ यापूर्वी ना परतावा अग्रीम धन घेतले आहे काय :- </td>
                <td className="text-left"> Yes / No</td>
              </tr>
              <tr>
                <td>१४ भ. नि. नि. खाते तयार करणाऱ्या लेखा विभागाचे नावं :-</td>
                <td className="text-left">
                  {formData && formData.approvingDepartmentName}
                </td>
              </tr>
              <tr>
                <td></td>
                <td className="text-center">
                  <textarea
                    className="form-control bg-white border-black"
                    readOnly
                  ></textarea>
                  <p className="fw-normal mb-0 p-0">अर्जदाराची स्वाक्षरी </p>
                  <p className=" mb-0 p-0 text-dark fw-bold">
                    {" "}
                    {formData && formData.applicantName}
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          id="section2"
          style={{
            border: "1px solid #000",
            marginBottom: "50px",
            marginTop: "50px",
            padding: "30px 20px",
          }}
        >
          <h4 className="vetan-cert my-3">{formData && formData.officeName}</h4>
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <p className="mt-1" style={{ fontSize: 20, fontWeight: "bold" }}>
              वेतन प्रमाणपत्र
            </p>
          </div>
          <p style={{ textIndent: "50px", textAlign: "justify" }}>
            प्रमाणित करण्यात येते की, या कार्यालयातील{" "}
            <strong>{formData && formData.applicantName}</strong> पदनाम{" "}
            <strong>{formData && formData.designation}</strong> यांचे माहे{" "}
            <strong>{formData && formData.salaryMonth}</strong> चे मासिक वेतन
            खालील प्रमाणे अदा करण्यात आले आहे.
          </p>
          <div className="row mt-4">
            <div className="col-lg-6 col-6 col-md-6 ">
              <table id="vetan_certi_table1" className="">
                <tr>
                  <th className="fw-bold text-center" colSpan={2}>
                    देय वेतन
                  </th>
                </tr>
                <tr>
                  <td>मूळ वेतन</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.basicPay}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>महागाई भत्ता</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.dearnessAllowance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>घरभाडे</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.houseRentAllowance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>वाहतूक भत्ता</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.transportAllowance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>कायम प्रवास भत्ता</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.permanentTravelAllowance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>महागाई भत्ता फरक</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.dearnessDifference}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>7 वा वेतन आयोग हफ्ता</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.seventhPayInstallment}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>धुलाई भत्ता</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.washingAllowance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>बेसीक arrears</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.basicArrears}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Other-1</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.other1}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Other-2</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.other2}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold ">एकूण देय वेतन</td>
                  <td className="fw-bold ">
                    <span class="text-danger">
                      {formData && formData.grossPayableSalary}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
            <div className="col-lg-6 col-6 col-md-6 ">
              <table id="vetan_certi_table2" className="">
                <tr>
                  <th className="fw-bold text-center" colSpan={2}>
                    कपात रक्कम
                  </th>
                </tr>
                <tr>
                  <td>व्यवसाय कर</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.professionTax}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>गट विमा</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.groupInsurance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>भ.नि.नि. वर्गणी</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.bhininiVargani}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>सण अग्रिम</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.festivalAdvance}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>एल आय सी</td>
                  <td>
                    <span class="text-danger">{formData && formData.lic}</span>
                  </td>
                </tr>
                <tr>
                  <td>जी प पतसंस्था</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.gppatSanstha}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>आरोग्य पतसंस्था</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.arogyapatSanstha}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>ग्रामसेवक पतसंस्था</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.gramsevakPatSanstha}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>गटविमा गृहकर्ज</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.groupInsuranceHomeLoan}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>रशीद तिकीट</td>
                  <td>
                    <span class="text-danger">
                      {formData && formData.receiptTicket}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>-</td>
                  <td>-</td>
                </tr>
                <tr>
                  <td className="fw-bold ">एकूण कपात वेतन</td>
                  <td className="fw-bold">
                    <span class="text-danger">
                      {formData && formData.totalDeductions}
                    </span>
                  </td>
                </tr>
              </table>
              <table id="vetan_certi_table2" className="">
                <tr>
                  <td className="fw-bold ">निव्वळ देय वेतन</td>
                  <td className="fw-bold ">
                    <span class="text-danger">
                      {formData && formData.netPaySalary}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div className="row my-5">
            <div className="col-lg-6 col-4 "></div>
            <div className="col-lg-6 col-8 text-center">
              <label className="text-danger fw-bold">
                {formData && formData.officeHeadDesignation}
              </label>
              <br />
              <label className="text-danger fw-bold">
                {formData && formData.officeName}
              </label>
            </div>
          </div>
        </div>
        <div
          id="section3"
          style={{
            border: "1px solid #000",
            marginBottom: "50px",
            marginTop: "50px",
            padding: "40px 20px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 15 }}>
            <p className="mt-1 text-dark" id="main-heading1">
              ना परतावा अग्रीम धनासाठी प्रमाणपत्र
            </p>
          </div>
          <p className="mt-4">
            <span>
              १ प्रमाणित करण्यात येते की, मी भविष्य निर्वाह निधीच्या कर्जाच्या
              अर्जावर{" "}
              <strong>{formData && formData.officeHeadDesignation}</strong>{" "}
              यांचे समक्ष स्वतः स्वाक्षरी केली आहे.
            </span>
          </p>
          <p className=" py-3 mt-3">
            <span>
              २ यापूर्वी घेतलेले अग्रीम मी दर्शविलेल्या कारणांसाठीच म्हणजे या
              कारणासाठीच त्याचा विनीयोग केला आहे
            </span>
          </p>
          <p className="my-3 mt-3">
            ३ आता पाहिजे असलेले अग्रीम
            <strong className="text-danger ps-4 pe-4">
              {formData && formData.reasonForAdvance}
            </strong>
            या कारणासाठीच त्याचा विनीयोग करीत आहे.
          </p>
          <div className="row mt-4 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold">
                स्थळ :-{" "}
                <label className="text-danger fw-bold">
                  {formData && formData.officeName}
                </label>
              </p>
              <p className="fw-bold">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center">
              <p>आपला विश्वासू,</p>
              <input type="text" className="form-control py-3 my-2" />
              <p className="fw-bold">{formData && formData.applicantName}</p>
              <p className="fw-bold">{formData && formData.designation}</p>
            </div>
          </div>
        </div>
        <div
          id="section4"
          style={{
            border: "1px solid #000",
            marginBottom: "50px",
            marginTop: "50px",
            padding: "40px 20px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 15 }}>
            <p className="mt-1 text-dark" id="main-heading1">
              प्रमाणपत्र
            </p>
          </div>
          <p className="mt-4">
            १ प्रमाणित करण्यात येते की,
            <strong>
              {" "}
              {formData && formData.applicantName} {"  "}{" "}
              {formData && formData.designation}
            </strong>{" "}
            यांची जन्म दिनांक, प्रथम नेमणूक दिनांक, सेवानिवृत्ती दिनांक व
            आजरोजीची एकूण सेवा याबाबत माहिती खालील प्रमाणे आहे.
          </p>
          <div className="row my-4">
            <div className="col-lg-4 col-6 col-md-6">
              <p className="fw-bold d-flex justify-between align-items-center">
                जन्म दिनांक :-{" "}
                <span className="form-control w-50">
                  {" "}
                  {formData && formData.dob}
                </span>
              </p>
              <p className="fw-bold d-flex justify-between align-items-center mt-3">
                प्रथम नेमणूक दिनांक :-{" "}
                <span className="form-control w-50">
                  {" "}
                  {formData && formData.firstAppointmentDate}
                </span>
              </p>
            </div>
            <div className="col-lg-5 col-6 col-md-6">
              <p className="fw-bold d-flex justify-between align-items-center">
                सेवा निवृत्ती दिनांक :-{" "}
                <span className="form-control w-50">
                  {" "}
                  {formData && formData.retirementDate}
                </span>
              </p>
              <p className="fw-bold d-flex justify-between align-items-center mt-3">
                आजरोजी झालेली सेवा :-{" "}
                <span className="form-control w-50">
                  {" "}
                  {formData && formData.serviceDuration}
                </span>
              </p>
            </div>
            <div className="col-12 px-0 mt-3">
              <p>
                उपरोक्त माहीती कार्यालयीन अभिलेख्यावरुन प्रमाणित करण्यात येत
                आहे.
              </p>
            </div>
          </div>
          <p className="py-3">
            <span>
              २ प्रमाणित करण्यात येते की,{" "}
              <strong>
                {" "}
                {formData && formData.applicantName} {"  "}{" "}
                {formData && formData.designation}
              </strong>{" "}
              यांच्या नाम निर्देशनाबाबतची नोंद त्यांचे मूळ सेवापुस्तिकेत घेण्यात
              आलेली आहे. करीता प्रमाणित करण्यात येत आहे.
            </span>
          </p>
          <div className="row mt-3">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold">
                स्थळ :-{" "}
                <label className="text-danger fw-bold">
                  {formData && formData.officeName}
                </label>
              </p>
              <p className="fw-bold">दिनांक :-</p>
            </div>
            <div className="col-lg-4 col-4 col-md-4 text-center">
              <p className="fw-bold">
                {formData && formData.officeHeadDesignation}
              </p>
              <p className="fw-bold">{formData && formData.officeName}</p>
            </div>
          </div>
        </div>
        <div
          id="section5"
          style={{
            border: "1px solid #000",
            marginBottom: "50px",
            marginTop: "50px",
            padding: "40px 20px",
          }}
        >
          <div className="row">
            <div className="col-lg-7 col-7 col-md-7"></div>
            <div className="col-lg-5 col-5 col-md-5">
              <p className="fw-bold text-danger">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold text-danger">
                {formData && formData.officeName}
              </p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6 col-6 col-md-6">
              <p className="fw-bold ">प्रति,</p>
              <p className="fw-bold text-danger">
                {formData && formData.submissionOffice}
              </p>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 ">
              <p className="fw-bold text-center">
                विषय : भविष्य निर्वाह निधी ना परतावा अग्रीम प्रस्ताव सादर करणे
                बाबत{" "}
              </p>
              <p className="fw-bold text-center mt-3">
                {formData && formData.applicantName}{" "}
                <span className="fw-normal">
                  {formData && formData.designation}
                </span>
              </p>

              <p className="mt-3">महोदय,</p>

              <p className="mt-3" style={{ textIndent: "30px", lineHeight: 2 }}>
                वरील विषयी य कार्यालयातील {formData && formData.applicantName}{" "}
                <span className="fw-normal">
                  {formData && formData.designation}
                </span>
                यांनी भविष्य निधी मधून ना परतावा अग्रीम रक्कम रु{" "}
                <strong className="text-danger">
                  {GPFNRData && GPFNRData.field6}
                </strong>{" "}
                मिळणेबाबतचा प्रस्ताव या कार्यालयास सादर केलेला आहे.
              </p>
              <p className="mt-3" style={{ textIndent: "30px" }}>
                करीता संबंधितांचा मूळ प्रस्ताव पुढील कार्यवाही व मंजूरीसाठी
                आपल्या कार्यालयाकडे सादर करण्यात येत आहे.{" "}
              </p>
              <p className="mt-3" style={{ textIndent: "30px" }}>
                कृपया सदर प्रस्तावास मंजुरी द्यावी हि विनंती
              </p>
            </div>
            <div className="row mt-5">
              <div className="col-lg-8 col-8 col-md-8"></div>
              <div className="col-lg-4 col-4 col-md-4 text-center">
                <p className="fw-bold">
                  {formData && formData.officeHeadDesignation}
                </p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          id="section6"
          style={{
            marginBottom: "50px",
            marginTop: "50px",
            padding: "30px 0px",
          }}
        >
          <table id="vetan_certi_table3" className="">
            <thead>
              <tr>
                <th
                  colSpan={9}
                  className="fw-bold p-2 text-center"
                  style={{ fontSize: 20 }}
                >
                  मुख्य लेखा व वित्त अधिकारी यांनी प्रमाणित केलेल्या वार्षिक
                  जमेनंतर जमा झालेल्या रकमेचा तपशिल{" "}
                </th>
              </tr>
              <tr>
                <th colSpan={6} className="fw-bold p-2 text-base">
                  अर्जदाराचे नांव :- {formData && formData.applicantName}
                </th>
                <th className="fw-bold p-2 text-base" colSpan={3}>
                  भनि नि क्रमांक :- {formData && formData.gpfNumber}
                </th>
              </tr>
              <tr>
                <th className=" text-center" rowSpan={2}>
                  अक्र
                </th>
                <th className=" text-center" rowSpan={2}>
                  महिना
                </th>
                <th className=" text-center" rowSpan={2}>
                  वर्गणी
                </th>
                <th
                  className=" text-center flex-nowrap"
                  style={{ textWrap: "nowrap" }}
                  rowSpan={2}
                >
                  वेतन आयोग हप्ता
                </th>
                <th className=" text-center" rowSpan={2}>
                  एकूण
                </th>
                <th
                  className=" text-center flex-nowrap"
                  style={{ textWrap: "nowrap" }}
                  rowSpan={2}
                >
                  कर्ज परत रक्कम
                </th>
                <th className=" text-center" colSpan={3}>
                  घेतलेले कर्ज
                </th>
              </tr>
              <tr>
                <th className=" text-center">रक्कम </th>
                <th
                  className=" text-center flex-nowrap"
                  style={{ textWrap: "nowrap" }}
                >
                  चेक क्र.{" "}
                </th>
                <th className=" text-center">दिनांक</th>
              </tr>
            </thead>
            <tbody>
              {deductionData &&
                deductionData.monthlyData.map((row, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="fw-bold text-center">{index + 1}</td>
                    <td className="fw-bold" style={{ textWrap: "nowrap" }}>
                      {row.month}
                    </td>
                    <td className="fw-bold text-center">{row.amount}</td>
                    <td className="fw-bold text-center">{row.contribution}</td>
                    <td className="fw-bold text-center">{row.total}</td>
                    <td className="fw-bold text-center">0</td>
                    <td className="fw-bold text-center">0</td>
                    <td className="fw-bold text-center">0</td>
                    <td className="fw-bold text-center">0</td>
                  </tr>
                ))}

              <tr className="font-semibold bg-gray-100">
                <td
                  colSpan="2"
                  className="fw-bold"
                  style={{ textWrap: "nowrap" }}
                >
                  एकूण जमा रक्कम
                </td>
                <td className="fw-bold text-center">
                  {deductionData && deductionData.totalContributions.amount}
                </td>
                <td className="fw-bold text-center">
                  {deductionData &&
                    deductionData.totalContributions.contribution}
                </td>
                <td className="fw-bold text-center">
                  {deductionData && deductionData.totalContributions.total}
                </td>
                <td className="fw-bold text-center">0</td>
                <td className="fw-bold text-center">0</td>
                <td className="fw-bold text-center">0</td>
                <td className="fw-bold text-center">0</td>
              </tr>
              <tr className="font-semibold bg-gray-100">
                <td
                  rowSpan={8}
                  colSpan={3}
                  className="text-center"
                  style={{ verticalAlign: "bottom" }}
                >
                  <label className="text-dark fw-bold">
                    {formData && formData.officeHeadDesignation}
                  </label>
                  <br />
                  <label className="text-dark fw-bold">
                    {formData && formData.officeName}
                  </label>
                </td>
                <td colSpan={5} className="text-danger">
                  मा.मु.ले. व वि.अ. यांनी सन २०२३-२४ मध्ये प्रमाणित केलेली रक्कम
                </td>
                <td className="text-danger">{GPFNRData && GPFNRData.field1}</td>
              </tr>
              <tr>
                <td colSpan={5}> चालू वर्षात मासिक हप्त्याचे जमा रक्कम</td>
                <td>
                  {deductionData && deductionData.totalContributions.total}
                </td>
              </tr>

              <tr>
                <td colSpan={5} className="text-danger">
                  सातवा वेतन आयोग ५ वा जमा हप्ता
                </td>
                <td className="text-danger">{GPFNRData && GPFNRData.field3}</td>
              </tr>
              <tr>
                <td colSpan={5}> एकूण खात्यावर जमा असलेली रक्कम</td>
                <td>{GPFNRData && GPFNRData.totalField4}</td>
              </tr>
              <tr>
                <td colSpan={5}> उपरोक्त कालावधीत घेतलेले कर्ज</td>
                <td>{GPFNRData && GPFNRData.field4}</td>
              </tr>
              <tr>
                <td colSpan={5}> अर्जदाराचे खाती शिल्लक शिल्लक रक्कम</td>
                <td>{GPFNRData && GPFNRData.remainingField6}</td>
              </tr>
              <tr>
                <td colSpan={5}> पूर्वीच्या कर्जाची येणे बाकी असलेली रक्कम</td>
                <td>{GPFNRData && GPFNRData.field5}</td>
              </tr>
              <tr>
                <td colSpan={5}>आता मागणी केलेले कर्ज (जमा रक्कम * ३/४)</td>
                <td>{GPFNRData && GPFNRData.field6}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          id="section7"
          style={{
            border: "1px solid #000",
            marginBottom: "50px",
            marginTop: "50px",
            padding: "40px 20px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: 10 }}>
            <p className="mt-1" style={{ fontSize: 24, fontWeight: "bold" }}>
              आगाऊ पावती / Advance Receipt
            </p>
          </div>
          <div
            className="my-4"
            style={{ textAlign: "center", marginBottom: 10 }}
          >
            <p className="my-2 text-dark p-3" id="main-heading1">
              जिल्हा परिषद / शासकीय कर्मचाऱयांना लागू केलेल्या राज्य शासकीय
              कर्मचाऱ्यांची ठेव संलग्न योजनेचा लाभ मिळण्यासाठी
            </p>
          </div>
          <div className="row mt-3">
            <div className="col-12 ">
              <p
                className="fw-bold"
                style={{ textIndent: 40, lineHeight: 2.5 }}
              >
                {formData && formData.applicantName}{" "}
                {formData && formData.designation} यांना नियमाप्रमाणे अनुज्ञेय
                असलेली रक्कम जमा / शिल्लक असलेल्या भविष्य निर्वाह निधीमधून
                मिळण्याचा हक्क असलेली
              </p>
            </div>
            <div className="col-9 ">
              <p style={{ textIndent: "30px", marginTop: 5 }}>
                एकूण रक्कम :-{" "}
                <strong className="text-danger">
                  {GPFNRData && GPFNRData.field6}
                </strong>{" "}
              </p>
              <p style={{ textIndent: "30px" }}>
                अक्षरी रक्कम रुपये :-{" "}
                <strong className="text-danger">
                  {convertAmountToText(
                    GPFNRData && GPFNRData.field6 > 0
                      ? GPFNRData && GPFNRData.field6
                      : 0
                  )}
                </strong>{" "}
              </p>
              <p style={{ fontWeight: "bold", marginTop: 5 }}>
                मात्र मिळाली आहे.
              </p>
            </div>
            <div className="col-3 ">
              <p
                className="form-control text-center bg-white text-sm"
                readOnly
                rows={3}
              >
                येथे <br /> रशिद तिकीट <br /> चिटकवावे
              </p>
            </div>
            <div className="row mt-5 g-2">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold">
                  स्थळ :-{" "}
                  <label className="text-danger fw-bold">
                    {formData && formData.officeName}
                  </label>
                </p>
                <p className="fw-bold">दिनांक :-</p>
              </div>
              <div className="col-lg-4 col-4 col-md-4 text-center">
                <p className="fw-bold">{formData && formData.applicantName}</p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
            <div className="row mt-5 g-2">
              <div className="col-lg-12 col-12 col-md-12">
                <p className="text-dark fw-bold">
                  माझ्या बँकेचा तपशील खालील प्रमाणे आहे.
                </p>
                <table id="bank-details" className="w-50">
                  <thead>
                    <tr>
                      <th className="fw-bold p-2">१ बँकेचे नाव :-</th>
                      <th className="fw-bold p-2">
                        {formData && formData.bankName}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-bold p-2">२ शाखा :-</th>
                      <th className="fw-bold p-2">
                        {formData && formData.branchName}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-bold p-2">३ बँक खाते क्रमांक :-</th>
                      <th className="fw-bold p-2">
                        {formData && formData.accountNumber}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-bold p-2">४ IFSC कोड :-</th>
                      <th className="fw-bold p-2">
                        {formData && formData.ifscCode}
                      </th>
                    </tr>
                    <tr>
                      <th className="fw-bold p-2">५ मोबाईल क्र. :-</th>
                      <th className="fw-bold p-2">
                        {formData && formData.mobileNumber}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-8 col-8 col-md-8"></div>
              <div className="col-lg-4 col-4 col-md-4 text-center">
                <p className="fw-bold">
                  {formData && formData.officeHeadDesignation}
                </p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4" id="button-section">
        {/* <div className="col-lg-3 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => printDiv()}
          >
            Print
          </button>
        </div> */}
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default GpfnrWorkPrint;
// a*N#b@..b@l5
// sigmaticsuperf_wadgaonkar_user
